import { Button, Checkbox, Modal } from "antd";

export default function DeleteNextInstructor({ props }) {
  return (
    <div className={"pb-3 pr-2 w-fit"}>
      <Button type="primary" onClick={props.toggleDeletePopup}>
        Delete
      </Button>

      <Modal
        visible={props.deleteVisible}
        title="Delete this next-instructor data?"
        onCancel={props.toggleDeletePopup}
        footer={[
          <Button key="Back" onClick={props.toggleDeletePopup}>
            Return
          </Button>,
          <Button
            type="danger"
            key="Delete"
            className={"btn btn-success"}
            loading={props.loading}
            onClick={props.hardDelete}
          >
            Permanent Delete
          </Button>,
        ]}
      >
        <div className="p-2">
          The total number of <strong>{props.selectRowID.length}</strong> item have
          been select for deletion
        </div>

        <div className="p-2">
          <strong>Check all</strong> the items below to confirm next-instuctor
          deletion, Deleting a next-instuctor is permanent and{" "}
          <strong>cannot</strong> be undone
        </div>

        <div className="frame-detail">
          <div>
            <Checkbox
              onChange={(value) => {
                props.setCheckBox1(value.target.checked);
              }}
              checked={props.checkBox1}
            >
              Any future access of the data will be impossible
            </Checkbox>
          </div>

          <div>
            <Checkbox
              onChange={(value) => {
                props.setCheckBox2(value.target.checked);
              }}
              checked={props.checkBox2}
            >
              This action cannot be undone
            </Checkbox>
          </div>
        </div>
      </Modal>
    </div>
  );
}
